import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
  CircularProgress,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";
import { Alert, Autocomplete } from "@material-ui/lab";
import {
  FETCH_INTERSTATE_DRIVERS,
  FETCH_INTERSTATE_DRIVERS_FAILURE,
  FETCH_INTERSTATE_DRIVERS_SUCCESS,
  FETCH_INTERSTATE_JOBS_ASSIGN,
  FETCH_INTERSTATE_JOBS_ASSIGN_FAILURE,
  FETCH_INTERSTATE_JOBS_ASSIGN_SUCCESS
} from "@utils/actionTypes";
import API from "@services/axios";
import { vehicleOptions, swapType } from "@utils/constant";

import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { AssignDriverStyle } from "./style";
import SelectJobPopup from "./select-job-popup";

function AssignDriverHandoffPopup(props) {
  const [state, dispatch] = useStore();
  const classes = AssignDriverStyle();
  const materialClasses = materialCommonStyles();
  const [scroll] = useState("body");
  const [openSelectJobPopup, setOpenSelectJobPopup] = useState(false);
  const [selectedJobArray, setSelectedJobArray] = useState([]);
  const listDrivers = state?.driver?.getInterstateDriverData || [];
  const [radioValue, setRadioValue] = useState("all-jobs");
  const [sort, setSort] = useState({
    order: "",
    orderBy: ""
  });

  const getDriverForAssignHandoff = () => {
    dispatch({ type: FETCH_INTERSTATE_DRIVERS });
    API.get("drivers/interstate", {
      params: props.actorDriverId ? {
        driverId: props.actorDriverId,
      } : {}
    })
      .then((response) => {
        dispatch({
          type: FETCH_INTERSTATE_DRIVERS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_INTERSTATE_DRIVERS_FAILURE, payload: error });
      });
  };

  const getInterstateJobsAssignHandoff = (eventId, payload) => {
    dispatch({ type: FETCH_INTERSTATE_JOBS_ASSIGN });
    API.get(`interstateJobPool/assignJobs/${eventId}`, { params: payload })
      .then((response) => {
        dispatch({
          type: FETCH_INTERSTATE_JOBS_ASSIGN_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_INTERSTATE_JOBS_ASSIGN_FAILURE, payload: error });
      });
  }

  useEffect(() => {
    if (props.open) {
      getDriverForAssignHandoff();
      getInterstateJobsAssignHandoff(props.eventId, {});
      props.formik.setFieldValue("swapType", props.swapType);
      props.formik.setFieldValue("listJobs", props.listJobIds);
    }
  }, [props.open]);

  const handleOpenSelectJobPopup = () => {
    setOpenSelectJobPopup(true);
    setSelectedJobArray(props.formik.values.listJobs);
  }

  const handleCloseSelectJobPopup = () => {
    setOpenSelectJobPopup(false);
    setSelectedJobArray([]);
  }

  const handleConfirmSelectJob = () => {
    if (selectedJobArray.length > 0) {
      if (selectedJobArray.length === state.jobPool?.interstateJobsAssignData?.length) {
        props.formik.setFieldValue("isFullAssignment", true);
        setRadioValue("all-jobs");
      }
      props.formik.setFieldValue("listJobs", selectedJobArray);
    } else {
      props.formik.setFieldValue("listJobs", []);
    }
    handleCloseSelectJobPopup();
  }

  const handleChange = (item) => {
    let jobId = item.id;
    const selectedIndex = selectedJobArray.indexOf(jobId);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedJobArray, jobId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedJobArray.slice(1));
    } else if (selectedIndex === selectedJobArray.length - 1) {
      newSelected = newSelected.concat(selectedJobArray.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedJobArray.slice(0, selectedIndex),
        selectedJobArray.slice(selectedIndex + 1),
      );
    }
    setSelectedJobArray(newSelected);
  }

  const handleMainChangeCheckBox = (e) => {
    if (e.target.checked) {
      const newSelected = state.jobPool?.interstateJobsAssignData.map((job) => job.id);
      setSelectedJobArray(newSelected);
    } else {
      setSelectedJobArray([]);
    }
  };

  const handleChangeRadio = (value) => {
    setRadioValue(value);
    if (value === "some-jobs") {
      props.formik.setFieldValue("swapType", swapType.jobOnly);
      props.formik.setFieldValue("isFullAssignment", false);
    } else {
      props.formik.setFieldValue("swapType", props.swapType);
      props.formik.setFieldValue("isFullAssignment", true);
    }
  };

  const handleSorting = (event, item) => {
    let isAsc = sort.orderBy === item.sortTitle && sort.order === "asc";
    setSort(prev => (
      {
        ...prev,
        order: isAsc ? "desc" : "asc",
        orderBy: item.sortTitle
      }
    ));
    let payload = {
      orderBy: item.sortTitle,
      order: isAsc ? "desc" : "asc",
    };
    payload = {
      ...payload
    };
    getInterstateJobsAssignHandoff(props.eventId,payload);
  };

  const handleCloseAll = () => {
    setRadioValue("all-jobs");
    setSort({
      order: "",
      orderBy: ""
    });
    props.handleClose();
  }

  return (
    <>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
        scroll={scroll}
      >
        <div className="close-modal">
          <img src={closeIcon} alt="Close" onClick={handleCloseAll} />
        </div>
        {props.error && <Alert severity="error">{props.error}</Alert>}
        <DialogTitle id="alert-dialog-title">
          Assign Driver
        </DialogTitle>
        <form
          noValidate
          autoComplete="off"
          className={classes.customForm}
          onSubmit={props.formik.handleSubmit}
        >
          <DialogContent>
            <div className="form-row">
              <div className="form-group">
                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text"></label>
                  <RadioGroup
                    aria-labelledby="assign-job"
                    value={radioValue}
                    name="assign-job"
                    onChange={e => handleChangeRadio(e.target.value)}
                    row
                  >
                    <FormControlLabel value="some-jobs" control={<Radio color="primary"/>} label="Local Portion Assignment" />
                    <FormControlLabel value="all-jobs" control={<Radio color="primary"/>} label="Full Assignment" />
                  </RadioGroup>
                </FormControl>

                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Vehicle Options</label>
                  <Select
                    id="swapType"
                    displayEmpty
                    className={materialClasses.customSelect}
                    MenuProps={{
                      classes: { paper: materialClasses.customSelect },
                    }}
                    onChange={props.formik.handleChange("swapType")}
                    value={props.formik.values.swapType}
                    IconComponent={() => <ExpandMore />}
                    disabled={radioValue === "some-jobs" || (props.formik.values.isFullAssignment && props.swapType === swapType.jobOnly)}
                  >
                    <MenuItem value={""} disabled>
                      Select Options
                    </MenuItem>
                    {(
                      vehicleOptions?.map((itm, indx) => {
                        if (props.swapType === itm.value || itm.value === swapType.jobOnly) {
                          return (
                            <MenuItem key={indx} value={itm.value}>
                              {itm.name}
                            </MenuItem>
                          );
                        } else {
                          return null;
                        }
                      })
                    )}
                  </Select>
                  <FormHelperText className="error-text">
                    {props.formik.touched.swapType &&
                      props.formik.errors.swapType}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Driver</label>
                  <Autocomplete
                    id="assignDriver"
                    popupIcon={<ExpandMore />}
                    className={materialClasses.inputAutoComplete}
                    options={listDrivers}
                    getOptionLabel={(option) => option.name}
                    value={
                      listDrivers?.find((opt) => opt.id === props.formik.values.assignDriver) || null
                    }
                    onChange={props.formik.handleChange("assignDriver")}
                    disableClearable
                    loading={state?.driver?.gettingInterstateDriver}
                    loadingText="Loading..."
                    noOptionsText="No options"
                    renderOption={(option) => (
                      <ul className={materialClasses.dropdownAutoComplete}>
                        <MenuItem
                          key={option.id}
                          value={option.id}

                        >
                          {option.name}
                        </MenuItem>
                      </ul>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="outlined"
                        className="label-text"
                        placeholder={"Search interstate driver"}
                      />
                    )}
                  />
                  <FormHelperText className="error-text">
                    {props.formik.touched.assignDriver &&
                      props.formik.errors.assignDriver}
                  </FormHelperText>
                </FormControl>

                {radioValue === "some-jobs" && (
                  <FormControl variant="outlined" className={classes.formControl}>
                    <label className="label-text"></label>
                    <Button
                      id="listJobs"
                      className="primary-btn linkButton"
                      color="inherit"
                      disableElevation
                      underlinenone="true"
                      onClick={handleOpenSelectJobPopup}
                    >
                      SELECT JOBS
                    </Button>
                    <FormHelperText className="error-text">
                      {props.formik.touched.listJobs &&
                        props.formik.errors.listJobs}
                    </FormHelperText>
                  </FormControl>)}
              </div>
            </div>

          </DialogContent>
          <DialogActions className="bottom-button-block">
            <Button
              className="primary-btn gray-border-btn"
              color="inherit"
              disableElevation
              onClick={handleCloseAll}
            >
              CANCEL
            </Button>
            <Button
              className="orange-btn primary-btn center-loading-indicator"
              color="inherit"
              disableElevation
              type="submit"
              disabled={
                state.driver?.gettingInterstateDriver ||
                state.jobPool?.assigningInterstateJobsStartedInPool ||
                state.jobPool?.gettingInterstateJobsAssign
              }
            >
              {
                state.driver?.gettingInterstateDriver ||
                state.jobPool?.assigningInterstateJobsStartedInPool ||
                  state.jobPool?.gettingInterstateJobsAssign ? (
                  <CircularProgress color="inherit" />
                ) : (
                  "ASSIGN"
                )
              }
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <SelectJobPopup
        handleClose={handleCloseSelectJobPopup}
        open={openSelectJobPopup}
        formik={props.formik}
        selectedJobArray={selectedJobArray}
        handleChange={handleChange}
        handleMainChange={handleMainChangeCheckBox}
        handleConfirmSelectJob={handleConfirmSelectJob}
        handleSorting={handleSorting}
        order={sort.order}
        orderBy={sort.orderBy}
      />
    </>
  );
}

export default AssignDriverHandoffPopup;
